import request from '../../../api/request';
import {
  AcademicOfferResponse,
  AdmissionUpdateBody,
  ProcessListResponse,
  ProcessUpdateBody,
} from './types';

const ENDPOINTS = {
  GET_ACADEMIC_OFFERS:
    'maintainers-portal/general-configuration/academic-offer-configuration/get-academic-offers',
  GET_PROCESS_LIST: (academicOfferId: number) =>
    `maintainers-portal/general-configuration/academic-offer-configuration/get-tuition-processes/${academicOfferId}`,
  UPDATE_TUITION_PROCESS: (tuitionProcessId: number) =>
    `maintainers-portal/general-configuration/academic-offer-configuration/update-tuition-process/${tuitionProcessId}`,
  UPDATE_ADMISSION: (admissionId: number) =>
    `maintainers-portal/general-configuration/academic-offer-configuration/update-admission/${admissionId}`,
};

export const getAcademicOffers = () => {
  return request<AcademicOfferResponse>(ENDPOINTS.GET_ACADEMIC_OFFERS, {
    method: 'GET',
  });
};

export const getProcessList = (academicOfferId: number) => {
  return request<ProcessListResponse>(
    ENDPOINTS.GET_PROCESS_LIST(academicOfferId),
    {
      method: 'GET',
    },
  );
};

export const updateTuitionProcess = ({
  tuitionProcessId,
  data,
}: {
  tuitionProcessId: number;
  data: ProcessUpdateBody;
}) => {
  return request<ProcessListResponse>(
    ENDPOINTS.UPDATE_TUITION_PROCESS(tuitionProcessId),
    {
      method: 'PUT',
      data,
    },
  );
};

export const updateAdmission = ({
  admissionId,
  data,
}: {
  admissionId: number;
  data: AdmissionUpdateBody;
}) => {
  return request<AdmissionUpdateBody>(ENDPOINTS.UPDATE_ADMISSION(admissionId), {
    method: 'PUT',
    data,
  });
};
